import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SuccessIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50001 13.4751L4.02501 10.0001L2.84167 11.1751L7.50001 15.8334L17.5 5.83345L16.325 4.65845L7.50001 13.4751Z"
        fill="#00E2AC"
      />
    </SvgIcon>
  );
};

export default SuccessIcon;
